import { Pipe, PipeTransform } from '@angular/core';
import { BookingDetail, EntryType } from '@app/@core/data/models/booking-detail.model';
import { VendorTypeCategoryNames } from '@app/@core/data/models/vendor-type.model';

@Pipe({ name: 'Accommodation' })
export class AccommodationPipe implements PipeTransform {

  transform(detail: BookingDetail): string {
    if(
      detail.vendorType && 
      detail.vendorType.category && 
      detail.vendorType.category.name  === VendorTypeCategoryNames.ACCOMODATION
    ){
      return `${detail.days} Days`;
    }
    if(detail.entryType === EntryType.HOTELBEDS_HOTELS || detail.entryType === EntryType.STC){
      return `${detail.days} Days`;
    }
    if(detail.vendor && detail.vendorType && detail.vendorType.category  &&
        detail.vendorType.category.name === VendorTypeCategoryNames.SPECIAL &&
        detail.vendor.vendorType.category.name === VendorTypeCategoryNames.ACCOMODATION
      ){
        return `${detail.days} Days`;
    }
    return `${detail.days} Nights`;
  }
}
